import {
  SpreadsheetDefinition,
  SummaryDefinition,
  SummaryDefinitionListResponse,
  SummaryVisibility,
} from 'common/types/summaryDefinitions';

// Query Keys
export const SUMMARY_DEFINITIONS_QUERY_KEYS = {
  all: ['summaryDefinitions'] as const,
  global: () => [...SUMMARY_DEFINITIONS_QUERY_KEYS.all, 'global'] as const,
  firm: (firmId: number) => [...SUMMARY_DEFINITIONS_QUERY_KEYS.all, 'firm', firmId] as const,
  fund: (fundId: number) => [...SUMMARY_DEFINITIONS_QUERY_KEYS.all, 'fund', fundId] as const,
  firmDefinition: (firmId: number, definitionId: number) =>
    [...SUMMARY_DEFINITIONS_QUERY_KEYS.firm(firmId), definitionId] as const,
  fundDefinition: (fundId: number, definitionId: number) =>
    [...SUMMARY_DEFINITIONS_QUERY_KEYS.fund(fundId), definitionId] as const,
};

// Hook Parameters
export interface UseGetFirmDefinitionsParams {
  firmId: number;
  enabled?: boolean;
}

export interface UseGetFundDefinitionsParams {
  fundId: number;
  enabled?: boolean;
}

// Mutation Payloads
export interface CreateDefinitionPayload {
  name: string;
  spreadsheet_definition: SpreadsheetDefinition;
  visibility?: SummaryVisibility;
  cloned_from?: number | null;
}

export interface UpdateDefinitionPayload {
  name?: string;
  spreadsheet_definition?: SpreadsheetDefinition;
  visibility?: SummaryVisibility;
}

export interface UpdateOrderPayload {
  order: number[];
}

// Hook Return Types
export interface UseGetDefinitionsReturn {
  data: SummaryDefinitionListResponse | undefined;
  isLoading: boolean;
  isFetching: boolean;
  isError: boolean;
  error: Error | null;
  refetch: () => void;
}

export interface UseMutationReturn<TData, TVariables> {
  mutate: (variables: TVariables) => void;
  mutateAsync: (variables: TVariables) => Promise<TData>;
  isLoading: boolean;
  isError: boolean;
  error: Error | null;
  isSuccess: boolean;
  reset: () => void;
}

// Computed definition list (merges global + custom in order)
export interface OrderedDefinition extends SummaryDefinition {
  isGlobal: boolean;
}

export type { SummaryDefinition, SummaryDefinitionListResponse, SpreadsheetDefinition, SummaryVisibility };
